
const ProductionServices = () => {
  const services = [
    {
      title: "Corrosion Mitigation",
      icon: "ri-shield-line",
      description: "Advanced corrosion inhibitor programs to protect production equipment and pipelines",
      solutions: [
        "Continuous corrosion inhibitor injection systems",
        "Batch treatment programs for wells and flowlines",
        "Specialized inhibitors for CO2 and H2S environments",
        "Corrosion monitoring and analysis services"
      ]
    },
    {
      title: "Erosion Control",
      icon: "ri-hammer-line",
      description: "Comprehensive erosion control solutions for high-velocity production systems",
      solutions: [
        "Sand control chemicals and systems",
        "Velocity reduction additives",
        "Equipment protection coatings",
        "Erosion monitoring and mitigation strategies"
      ]
    },
    {
      title: "Scale Inhibition",
      icon: "ri-drop-line",
      description: "Effective scale prevention and removal solutions for production optimization",
      solutions: [
        "Continuous scale inhibitor squeeze treatments",
        "Scale removal and dissolution chemicals",
        "Precipitation inhibitors for water systems",
        "Scale prediction and monitoring services"
      ]
    },
    {
      title: "Scale Analysis",
      icon: "ri-microscope-line",
      description: "Comprehensive scale analysis and characterization services",
      solutions: [
        "Scale sample analysis and identification",
        "Scale formation tendency studies",
        "Inhibitor performance evaluation",
        "Custom scale mitigation strategies"
      ]
    },
    {
      title: "Stimulation Services",
      icon: "ri-rocket-line",
      description: "Well stimulation chemicals and services for productivity enhancement",
      solutions: [
        "Acid stimulation chemical systems",
        "Fracturing fluid additives",
        "Clay stabilization treatments",
        "Formation damage removal chemicals"
      ]
    },
    {
      title: "Pumping Services",
      icon: "ri-settings-4-line",
      description: "Professional chemical pumping and injection services",
      solutions: [
        "Chemical injection system design and installation",
        "Automated dosing and control systems",
        "Pump maintenance and calibration services",
        "Remote monitoring and optimization"
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Production Chemical Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialized chemical services to mitigate corrosion, erosion, scale deposit, 
            scale inhibition, scale analysis, stimulation and pumping services.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${service.icon} text-teal-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {service.description}
              </p>
              <div className="space-y-2">
                {service.solutions.map((solution, solutionIndex) => (
                  <div key={solutionIndex} className="flex items-start space-x-2">
                    <div className="w-4 h-4 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <p className="text-sm text-gray-700">{solution}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-lg shadow-lg p-8">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                ADNOC Onshore & Offshore Expertise
              </h3>
              <p className="text-gray-600 mb-6">
                Golden Black has extensive experience providing production chemical services 
                for ADNOC Onshore and Offshore operations, with deep understanding of UAE 
                reservoir conditions and operational requirements.
              </p>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-double-line text-teal-600 text-lg"></i>
                  <span className="text-gray-700">ADNOC approved chemical suppliers</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-double-line text-teal-600 text-lg"></i>
                  <span className="text-gray-700">Local UAE operations and support</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-double-line text-teal-600 text-lg"></i>
                  <span className="text-gray-700">24/7 technical support and emergency response</span>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/d568906deb29272a39ddfc5be2c10d7d.jpg"
                alt="ADNOC Services"
                className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductionServices;
